export default __webpack_public_path__ + "static/media/icoTwitter.cc2846f0.svg";